import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import {
  PATH_TO_CONTENT_STATS_STATE,
  PATH_TO_COURSE_STATS_STATE,
  PATH_TO_SECTION_STATS_STATE,
  PATH_TO_USER_STATS_STATE
} from "../../consts";
import * as contentStatsStateSelectors from "./contentStats";
import { ContentStatsStateSelectors } from "./contentStats/types";
import * as courseStatsStateSelectors from "./courseStats";
import { CourseStatsStateSelectors } from "./courseStats/types";
import * as sectionStatsStateSelectors from "./sectionStats";
import { SectionStatsStateSelectors } from "./sectionStats/types";
import * as userStatsStateSelectors from "./userStats";
import { UserStatsStateSelectors } from "./userStats/types";

type State = any;

function getUserStatsSlice(state: State): any {
  return state.get(PATH_TO_USER_STATS_STATE);
}

function getContentStatsSlice(state: State): any {
  return state.get(PATH_TO_CONTENT_STATS_STATE);
}

function getSectionStatsSlice(state: State): any {
  return state.get(PATH_TO_SECTION_STATS_STATE);
}

export function getCourseStatsStateSlice(state: any) {
  return state.get(PATH_TO_COURSE_STATS_STATE);
}

// @ts-ignore
export const {
  getTotalStudyTime: getUserTotalStudyTime,
  getSessionsCompleted: getUserSessionsCompleted,
  getUserLastStudied,
  getSessionModulesStudied: getUserSessionModulesStudied,
  getSessionModulesCorrect: getUserSessionModulesCorrect,
  getUserRecentlyStudiedCourses,
  getRecentlyStudiedCourseIds: getUserRecentlyStudiedCourseIds,
  userStatsFetching,
  userStatsFetchSucceeded,
  userStatsFetchErrored,
  userStatsFetchFinished,
  userStatsNeedsFetching
}: UserStatsStateSelectors<State> = composeSelectors(
  getUserStatsSlice,
  userStatsStateSelectors
);

// @ts-ignore
export const {
  getTimesStudied: getContentTimesStudied,
  getLastStudied: getContentLastStudied,
  getLastScore: getContentLastScore,
  getLastContentModuleId,
  lastTryWasIncorrect: lastTryForContentWasIncorrect,
  getContentStat,
  hasContentStat,
  getContentStats,
  allContentStatsForCourseFetching,
  allContentStatsForCourseFetchSucceeded,
  allContentStatsForCourseFetchErrored,
  allContentStatsForCourseFetchFinished,
  allContentStatsForCourseNeedsFetching
}: ContentStatsStateSelectors<State> = composeSelectors(
  getContentStatsSlice,
  contentStatsStateSelectors
);

// @ts-ignore
export const {
  hasSectionStat,
  getSectionStat,
  getTimesStudied: getSectionTimesStudied,
  getTotalStudyTime: getSectionTotalStudyTime,
  getBestScore: getSectionBestScore,
  getLastScore: getSectionLastScore,
  getSpacing: getSectionSpacing,
  getLastStudied: getSectionLastStudied,
  getModuleIdsIncorrectLast: getSectionModuleIdsIncorrectLast,
  getNumberOfModuleIdsIncorrect: getNumberOfSectionModuleIdsIncorrectLast,
  getAverageScore: getSectionAverageScore,
  getSectionStats,
  getSectionsStats,
  getStudiedSectionIds,
  allSectionStatsForCourseFetchErrored,
  allSectionStatsForCourseFetchFinished,
  allSectionStatsForCourseFetchSucceeded,
  allSectionStatsForCourseNeedsFetching
}: SectionStatsStateSelectors<State> = composeSelectors(
  getSectionStatsSlice,
  sectionStatsStateSelectors
);

// @ts-ignore
export const {
  getTotalStudyTime: getCourseTotalStudyTime,
  getScore: getCourseScore,
  getSessionsCompleted: getCourseSessionsCompleted,
  getNumberOfModulesStudied: getNumberOfModulesStudiedForCourse,
  getProficiency: getCourseProficiency,
  getLastStudied: getCourseLastStudied,
  courseStatFetchSucceeded,
  courseStatFetchErrored,
  courseStatFetchFinished,
  courseStatNeedsFetching,
  allCourseStatsFetchErrored,
  allCourseStatsFetchFinished,
  allCourseStatsNeedsFetching
}: CourseStatsStateSelectors<State> = composeSelectors(
  getCourseStatsStateSlice,
  courseStatsStateSelectors
);
